export default __webpack_public_path__ + "static/media/figuremarket.4d791ed5.png";